import { getApiCall, getChecklistMaster } from 'api/apiService';

import { GET_BUYERID, LOGGED_FROM, USER_MAIL_ID } from 'constant/app.config';

export const handleNonSolicitorAction = async (
  propertyId,
  binderid,
  title,
  subtitle,
  history,
  primaryUserTypeValue,
  setQuestionBox,
  creator,
  setSelectedBuyerid,
  setOpensolicitor,
  setShowMessage,
  setMessagedata
) => {
  const normalizedTitle = title?.trim().toLowerCase();

  if (
    normalizedTitle === 'new property listing added' ||
    normalizedTitle === 'property published'
  ) {
    history.push({
      pathname: `/dashboard`,
    });
  } else if (
    normalizedTitle === 'inspection completed' ||
    normalizedTitle === 'inspection review'
  ) {
    if (primaryUserTypeValue === 'Vendor') {
      history.push({
        pathname: `/dashboard/viewactive-dashboard/${propertyId}`,
      });

      setTimeout(() => {
        window.scrollTo({
          top: 1000,
          behavior: 'smooth',
        });
      }, 500);
    }

    if (primaryUserTypeValue === 'Buyer') {
      history.push({
        pathname: `/market/${propertyId}`,
      });
    }
  } else if (
    normalizedTitle === 'new offer received' ||
    normalizedTitle === 'offer accepted' ||
    normalizedTitle === 'offer rejected' ||
    normalizedTitle === 'offer withdrawn' ||
    normalizedTitle === 'counter offer received' ||
    normalizedTitle === 'current offer updated' ||
    normalizedTitle === 'new contract received' ||
    normalizedTitle === 'stage 2 - closed' ||
    normalizedTitle === 'stage 2 - final offers' ||
    normalizedTitle === 'property sold' ||
    normalizedTitle === 'campaign paused' ||
    normalizedTitle === 'campaign resumed' ||
    normalizedTitle === 'campaign ended' ||
    normalizedTitle === 'property added watchlist'
  ) {
    if (primaryUserTypeValue === 'Vendor') {
      history.push({
        pathname: `/dashboard/viewactive-dashboard/${propertyId}`,
      });
    }

    if (primaryUserTypeValue === 'Agent') {
      history.push({
        pathname: `/dashboard/view-dashboard/${propertyId}`,
      });
    }

    if (primaryUserTypeValue === 'Buyer') {
      history.push({
        pathname: `/market/${propertyId}`,
      });
    }
  } else if (normalizedTitle === 'profile set-up') {
    setQuestionBox(true);
  } else if (normalizedTitle === 'stage 2 - access request') {
    getApiCall(GET_BUYERID + creator).then((res) => {
      setSelectedBuyerid(res?.data?.userId);

      history.push({
        pathname: `/dashboard/view-dashboard/${propertyId}`,
      });
    });
  } else if (normalizedTitle === 'on-board legal representative') {
    setOpensolicitor(true);
  } else if (
    normalizedTitle === 'congratulations' ||
    normalizedTitle === 'congratulations! winner nominated!'
  ) {
    if (primaryUserTypeValue === 'Vendor') {
      history.push({
        pathname: `/dashboard/viewactive-dashboard/${propertyId}`,
      });
    }

    if (primaryUserTypeValue === 'Buyer') {
      getChecklistMaster(propertyId).then((res) => {
        if (res?.status == '1') {
          // Find the task with the name "Sign Contract"
          const signContractTask = res?.TaskList.find(
            (task) => task.taskName === 'Sign Contract'
          );

          // Extract the isDone value
          const isDone = signContractTask ? signContractTask.isDone : null;

          const binder = signContractTask ? signContractTask.binderId : null;

          if (isDone == 1) {
            history.push({
              pathname: `/market/${propertyId}`,
            });
          } else {
            if (LOGGED_FROM == 'Mobile') {
              window.open(
                `com.comm-app://LoginPage?mailid=${USER_MAIL_ID}&binder=${binder}`,
                '_blank'
              );
            } else {
              setShowMessage(true);
              setMessagedata({ binderId: binder });
            }
          }
        }
      });
    }
  } else if (normalizedTitle === 'private offer received') {
    const match = subtitle.match(/\$([\d,]+)/);
    const pricevalue = match ? match[1].replace(/,/g, '') : null;

    history.push({
      pathname: `/market/${propertyId}`,
      state: { propertyIds: propertyId, privateofferprice: pricevalue },
    });
  } else if (normalizedTitle === 'private offer requested') {
    const match = subtitle.match(/\$([\d,]+)/);
    const pricevalue = match ? match[1].replace(/,/g, '') : null;

    history.push({
      pathname: `/dashboard/viewactive-dashboard/${propertyId}`,
      state: { propertyIds: propertyId, privateofferprice: pricevalue },
    });
  } else {
    if (LOGGED_FROM == 'Mobile') {
      window.open(
        `com.comm-app://LoginPage?mailid=${USER_MAIL_ID}&binder=${binderid}`,
        '_blank'
      );
    } else {
      setShowMessage(true);
      setMessagedata({ binderId: binderid });
    }
  }
};
